import React, { createContext, useState, useContext } from 'react'
import axios from "axios";
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import moment from 'moment';
import CircularProgress from '@mui/material/CircularProgress';
moment.locale("ja", {
  weekdays: ["日曜日", "月曜日", "火曜日", "水曜日", "木曜日", "金曜日", "土曜日"],
  weekdaysShort: ["日", "月", "火", "水", "木", "金", "土"]
});

function OutsideTrainingList() {

  const [GridData, setGridData] = useState();
  const [loading, setLoading] = useState(false);//検索中

  React.useEffect(() => {
    setLoading(true);

    // let url = `http://localhost:5000/v1/training/events/search`;
    let url = process.env.REACT_APP_API_BASE_URL + `/v1/training/events/search`;

    axios.post(url, {
      syagai: true
    }).then((abc) => {
      console.log(abc.data);
      setGridData(JSON.parse(JSON.stringify(abc.data)));
      setLoading(false)
    });
  }, []);

  return (
    <Container style={{ height: window.innerHeight / 1.5, paddingLeft: 0, paddingRight: 0, maxWidth: 'none' }} sx={{ mb: 1 }}>
      {/* <Typography sx={{fontSize: 20, textAlign: 'left', color: '#357ebd', fontWeight: 'bold'}}>
      過去の提出履歴
    </Typography> */}
    ポリテクセンターの社外研修は２週間前までに申込を行うこと
      <TableContainer component={Paper} square elevation={0} align="center" sx={{ maxHeight: 600 }}>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow sx={{ backgroundColor: '#E6F3FC' }}>
              <TableCell align="center" sx={{ border: 1 }}>【社外研修】<br />日程</TableCell>
              <TableCell align="center" sx={{ border: 1 }}>区分</TableCell>
              <TableCell align="center" sx={{ border: 1 }}>カテゴリ</TableCell>
              <TableCell align="center" sx={{ border: 1 }}>タイトル</TableCell>
              <TableCell align="center" sx={{ border: 1 }}>主催者</TableCell>
              <TableCell align="center" sx={{ border: 1 }}>参加推奨<br />部門・階層</TableCell>
              <TableCell align="center" sx={{ border: 1 }}>定員</TableCell>
              <TableCell align="center" sx={{ border: 1 }}>場所</TableCell>
              <TableCell align="center" sx={{ border: 1 }}>時間</TableCell>
              <TableCell align="center" sx={{ border: 1 }}>金額(1名)</TableCell>
              <TableCell align="center" sx={{ border: 1 }}>コースNo.</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {GridData ? GridData.map((row) => (
              <TableRow key={row.id}>
                <TableCell align="center" sx={{ border: 1 }}>{moment(row.training_day).format('YYYY-MM-DD(ddd)')}</TableCell>
                <TableCell align="center" sx={{ border: 1 }}>社外</TableCell>
                <TableCell align="center" sx={{ border: 1 }}>{row.category_title}</TableCell>
                <TableCell align="center" sx={{ border: 1 }}>{row.title}</TableCell>
                <TableCell align="center" sx={{ border: 1 }}>{row.promoter}</TableCell>
                <TableCell align="center" sx={{ border: 1 }}>{row.recommended_section}</TableCell>
                <TableCell align="center" sx={{ border: 1 }}><span style={{color:"red"}}>{row.capacity}</span></TableCell>
                <TableCell align="center" sx={{ border: 1 }}>{row.place}</TableCell>
                <TableCell align="center" sx={{ border: 1 }}>{row.training_time}</TableCell>
                <TableCell align="center" sx={{ border: 1 }}>{row.training_amount}</TableCell>
                <TableCell align="center" sx={{ border: 1 }}>{row.course_number}</TableCell>
              </TableRow>
            )) : <CircularProgress color="inherit" />}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
};

export default OutsideTrainingList;
